import { useFrame, useThree } from '@react-three/fiber';
import { useMemo, useRef } from 'react';
import * as THREE from 'three';

import { fragmentShader } from '@/components/game/3d/shaders/coalSky/fragment';
import { vertexShader } from '@/components/game/3d/shaders/coalSky/vertex';

export default function FluidBackgroundCoal2() {
	const meshRef = useRef<THREE.Mesh>(null);

	const { camera } = useThree();

	const uniforms = useMemo(
		() => ({
			uTime: {
				value: 0,
			},
			uSpeed: {
				value: 0.35,
			},
		}),
		[]
	);

	useFrame((_, delta) => {
		uniforms.uTime.value += delta;

		if (meshRef.current) {
			meshRef.current.position.copy(camera.position);
		}
	});

	return (
		<mesh ref={meshRef} frustumCulled={false} renderOrder={-1000}>
			<sphereGeometry args={[500, 128, 128]} />

			<shaderMaterial
				uniforms={uniforms}
				vertexShader={vertexShader}
				fragmentShader={fragmentShader}
				side={THREE.BackSide}
				depthWrite={false}
				depthTest={true}
			/>
		</mesh>
	);
}
